<template>
  <div>
    <div v-if="layersLoading">
      <spinner class="layers-loading" :loading="layersLoading"></spinner>
    </div>
    <div v-else>
      <div>
        <b-form-group
          label="Dane systemowe w czasie"
          label-for="inventarization-range"
        >
          <b-input
            class="pl-3 pr-3"
            id="inventarization-range"
            v-model="selectedInventarizationValue"
            type="range"
            min="0"
            :max="historyTimelineInventarizations.length - 1"
            step="1"
            list="values"
          >
          </b-input>
          <datalist id="values">
            <option
              class="centered-option"
              v-if="
                historyTimelineInventarizations &&
                  historyTimelineInventarizations.length
              "
              v-for="historyTimelineInventarization in historyTimelineInventarizations"
              :key="historyTimelineInventarization.value"
              :value="historyTimelineInventarization.value"
              :label="historyTimelineInventarization.label"
              :class="
                historyTimelineInventarization.value ==
                selectedInventarizationValue
                  ? 'bold'
                  : ''
              "
            >
            </option>
          </datalist>
        </b-form-group>
      </div>
      <b-collapse
        class="mb-2"
        id="more-details-timeline"
        v-model="moreDetailsTimeline"
      >
        <div>
          <label for="clearLayerCheckbox" class="col-form-label ">
            Warstwy
          </label>
          <div class="mb-2">
            <div
              v-if="inventarizationLayers && inventarizationLayers.length"
              class="d-flex"
              v-for="layer in inventarizationLayers"
            >
              <b-form-checkbox
                @input="toggleVisible(layer)"
                v-model="layer.visible"
              ></b-form-checkbox
              ><span>{{ layer.title }}</span>
            </div>
          </div>
        </div>
        <b-row v-if="this.hasPermission('View_all_infrastructure_data')">
          <b-col class="col-md-6">
            <b-form-group
              label="Organizacja"
              label-for="organization-search-query-autocomplete"
            >
              <autocomplete
                ref="organizationSearchQuery"
                id="organization-search-query-autocomplete"
                v-model="organizationSearchQuery"
                :items="organizationAutocompleteItems"
                @update-items="organizationAutocompleteUpdated"
                :min-len="3"
                :input-attrs="{
                  placeholder: 'Wyszukaj',
                  class: 'form-control'
                }"
                :auto-select-one-item="false"
              >
              </autocomplete></b-form-group
          ></b-col>
        </b-row>
      </b-collapse>
      <b-row
        ><b-col class="d-flex justify-content-center"
          ><b-btn
            variant="primary"
            @click="moreDetailsTimeline = !moreDetailsTimeline"
            ><span v-if="moreDetailsTimeline">Zwiń</span
            ><span v-if="!moreDetailsTimeline">Rozwiń</span></b-btn
          >
        </b-col></b-row
      >
    </div>
  </div>
</template>

<script>
import Autocomplete from 'v-autocomplete';
import { Api as UsersApi } from '../../api/api-uzytkownicy.js';
import { mapGetters } from 'vuex';
import {
  SET_HISTORY_TIMELINE_INVENTARIZATIONS,
  SET_HISTORY_TIMELINE_INVENTARIZATION,
  SET_HISTORY_TIMELINE_ORGANIZATION,
  SET_LAYER_VISIBILITY
} from '../../store/mutations.type';
import {
  INVENTARIZATION_LAYERS_CREATE,
  INVENTARIZATION_LAYERS_SHOW,
  INVENTARIZATION_LAYERS_HIDE,
  CHANGE_INVENTARIZATION_LAYERS_HEADERS,
  REDRAW_INVENTARIZATION_LAYERS
} from '../../store/actions.type';
import Spinner from '../Spinner.vue';

export default {
  name: 'ArchiveLayersTimeline',
  components: { Autocomplete, Spinner },
  data() {
    return {
      selectedInventarizationValue: 0,
      moreDetailsTimeline: false,
      organization: '',
      organizationSearchQuery: null,
      organizationAutocompleteItems: []
    };
  },
  computed: {
    ...mapGetters([
      'historyTimelineActive',
      'featuresLayer',
      'historyTimelineInventarizations',
      'historyTimelineInventarization',
      'layersLoading',
      'inventarizationLayers'
    ])
  },
  props: {
    visible: false
  },
  async mounted() {
    await this.setHistoryTimelineInventarizations();
    this.setLatestHistoricalInventarization();
  },
  methods: {
    async toggleVisible(layer) {
      await this.$store.commit(SET_LAYER_VISIBILITY, {
        layerId: layer.id,
        visible: layer.visible
      });
    },
    async setHistoryTimelineInventarizations() {
      const archiveInventarizations = [
        { value: 0, label: '2014' },
        { value: 1, label: '2015' },
        { value: 2, label: '2016' },
        { value: 3, label: '2017' },
        { value: 4, label: '2018' },
        { value: 5, label: '2019' },
        { value: 6, label: '2020' },
        { value: 7, label: '2021' }
      ];
      const newInventarizations = [];
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const startYear = 2022;
      for (let year = startYear; year <= currentYear; year++) {
        if (year > 2050) {
          break;
        }
        let yearObject;
        yearObject = {
          value: archiveInventarizations.length + newInventarizations.length,
          label: `${year}_I`
        };
        newInventarizations.push(yearObject);
        if (currentYear != year || currentDate.getMonth() >= 6) {
          yearObject = {
            value: archiveInventarizations.length + newInventarizations.length,
            label: `${year}_II`
          };
          newInventarizations.push(yearObject);
        }
      }

      await this.$store.commit(SET_HISTORY_TIMELINE_INVENTARIZATIONS, [
        ...archiveInventarizations,
        ...newInventarizations
      ]);
    },
    setLatestHistoricalInventarization() {
      this.selectedInventarizationValue = this.historyTimelineInventarizations[
        this.historyTimelineInventarizations.length - 1
      ].value;
    },
    async organizationAutocompleteUpdated(text) {
      if (text.trim()) {
        try {
          const api = new UsersApi();

          const response = await api.getCboOrganizations({
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId,
            filter_str: text
          });

          if (response) {
            this.organizations = response.body.organizations;
            this.organizationAutocompleteItems = response.body.organizations.map(
              u => {
                return u.name;
              }
            );
          }
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Uwaga!',
            text: error,
            duration: 10000
          });
        }
      }
    }
  },
  watch: {
    layersLoading: {
      async handler(newValue, oldValue) {
        if (!newValue) {
          await this.$store.dispatch(INVENTARIZATION_LAYERS_CREATE);
        }
      }
    },
    historyTimelineInventarization: {
      async handler(newValue, oldValue) {
        if (!newValue) {
          await this.$store.dispatch(CHANGE_INVENTARIZATION_LAYERS_HEADERS);
          await this.$store.dispatch(REDRAW_INVENTARIZATION_LAYERS);
        }
      }
    },
    historyTimelineActive: {
      async handler(newValue, oldValue) {
        if (newValue) {
          // await this.$store.dispatch(INVENTARIZATION_LAYERS_SHOW);
        } else {
          await this.$store.dispatch(INVENTARIZATION_LAYERS_HIDE);
        }
      }
    },
    // selectedInventarizationValue: {
    // async handler(newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //     const selectedInventarization = this.historyTimelineInventarizations.find(
    //       inventarization => {
    //         return inventarization.value == newValue;
    //       }
    //     );
    //     window.console.log(selectedInventarization);
    //     if (selectedInventarization) {
    //       await this.$store.commit(
    //         SET_HISTORY_TIMELINE_INVENTARIZATION,
    //         selectedInventarization.label
    //       );
    //       // await this.$store.dispatch(INVENTARIZATION_LAYERS_SHOW);
    //       window.console.log(this.layers);
    //     } else {
    //       this.$notify({
    //         type: 'error',
    //         title: 'Uwaga!',
    //         text: 'Wystąpił błąd podczas Przełączania inwentaryzacji.',
    //         duration: 2000
    //       });
    //     }
    //   }
    // }
    // }
    selectedInventarizationValue: {
      deep: true,
      async handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          const selectedInventarization = this.historyTimelineInventarizations.find(
            inventarization => {
              return inventarization.value == newValue;
            }
          );
          if (selectedInventarization) {
            await this.$store.commit(
              SET_HISTORY_TIMELINE_INVENTARIZATION,
              selectedInventarization.label
            );
            await this.$store.dispatch(CHANGE_INVENTARIZATION_LAYERS_HEADERS);
            await this.$store.dispatch(REDRAW_INVENTARIZATION_LAYERS);
          }
        }
      }
    },
    async organizationSearchQuery(newVal) {
      if (newVal) {
        this.organization = this.organizations.find(el => {
          return this.organizationSearchQuery === el.name;
        }).id;
      } else {
        this.organization = '';
      }
      await this.$store.commit(
        SET_HISTORY_TIMELINE_ORGANIZATION,
        this.organization
      );
      await this.$store.dispatch(CHANGE_INVENTARIZATION_LAYERS_HEADERS);
      await this.$store.dispatch(REDRAW_INVENTARIZATION_LAYERS);
    }
  }
};
</script>

<style>
datalist {
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;

  /* writing-mode: vertical-lr; */
  min-width: 100%;
}

.centered-option {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  padding: 0.5rem;
}
datalist option:first-child {
  justify-content: start;
  /* width: 100px; */
}
datalist option:last-child {
  justify-content: end;
  /* width: 100px; */
}
/* option {
  padding: 0;
} */

input[type='range'] {
  min-width: calc(100%);
  /* width: calc(100%-2rem); */
  margin: 0;
}
.bold {
  font-weight: bold;
}
</style>
